import React, { useEffect } from 'react';
import { useVerifyExternalToken } from '../../hooks/useVerifyExternalToken';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Skeleton } from '@chakra-ui/react';
import OrgLandingPage from '../LandingPage/OrgLandingPage';

export const AutoLogin = () => {
	const location = useLocation();
	// Parse the query parameters to get the token
	const queryParams = new URLSearchParams(location.search);
	const token = queryParams.get('token');
	// Use the useVerifyExternalToken hook
	const { data, error } = useVerifyExternalToken(token || '');
	const navigate = useNavigate();
	// Effect to handle redirection in case of error
	useEffect(() => {
		if (!token) {
			// Redirect to google.com if no token is present
			window.location.href = 'http://sageextension.com/login';
		}
		if (error) {
			// Redirect to google.com in case of an error
			window.location.href = 'http://sageextension.com/login';
		}
	}, [error, token]);
	if (data) {
		if (data.haveSignedUp) {
			// Redirect to dashboard if the user has already signed up
			navigate(`/sign-in?token=${token}`);
		} else {
			navigate(`/sign-up?token=${token}`);
		}
	}
	return (
		<Box>
			<Skeleton isLoaded={data}>
				<OrgLandingPage />
			</Skeleton>
		</Box>
	);
};
